import z from 'zod';

import { EInterventionStatus } from '@enums/intervention.enum';
import { paginationSchema } from '@schemas/pagination.schema';

export const getAllInterventionsSchema = paginationSchema.extend({
  status: z.enum(EInterventionStatus).array().nonempty().optional(),
});

export type GetAllInterventionsParams = z.infer<
  typeof getAllInterventionsSchema
>;
